var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content", staticStyle: { "min-height": "200px" } },
    [
      _c(
        "v-layout",
        { staticStyle: { width: "100%", "max-height": "65vh" } },
        [
          _vm.canAddAssets
            ? _c("asset-selection", {
                attrs: {
                  template: _vm.template,
                  filters: _vm.filters,
                  "asset-reservation-objects": _vm.assets,
                  "layers-to-show": _vm.layersToShow,
                  "only-used-elements": _vm.onlyUsedElements
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canAddAssets
            ? _c("v-divider", { attrs: { vertical: "" } })
            : _vm._e(),
          _vm._v(" "),
          _c("selected-assets", {
            key: _vm.assets.length,
            attrs: {
              tab: "assets",
              "action-type": _vm.actionType,
              "asset-reservation-objects": _vm.assets,
              "user-can-add-objects": _vm.canAddAssets
            },
            on: {
              "update-asset-reservation-objects": function($event) {
                return _vm.$emit("update-assets", $event)
              },
              "add-asset-to-delete": _vm.addAssetToDelete
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67c5bc5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c5bc5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab.vue
// module id = null
// module chunks = 